import { Database, ref, set, update, onValue } from 'firebase/database';

export function setAppVersion({
  database,
  userId,
  device,
  version,
}: {
  database: Database;
  userId: string;
  device: 'ios' | 'android' | 'web';
  version: string;
}): Promise<void> {
  // const dataRef = ref(database, `users/${userId}/info/${device}/version`);
  // return set(dataRef, version);
  const userInfoRef = ref(database, `users/${userId}/info`);
  return update(userInfoRef, {
    [`${device}/version`]: version,
    lastLogin: new Date().toISOString(),
  });
}

export function setUserChannelPreferences({
  database,
  userId,
  channel,
  enabled,
  courierTemplateId,
}: {
  database: Database;
  userId: string;
  courierTemplateId: string;
  channel: 'email' | 'sms' | 'push';
  enabled: boolean;
}): Promise<void> {
  const userPreferencesRef = ref(
    database,
    `channelPreferences/${userId}/${courierTemplateId}/${channel}`
  );
  return set(userPreferencesRef, enabled);
}

export interface UserChannelPreferences {
  email: boolean;
  sms: boolean;
  push: boolean;
}

export function getUserChannelPreferences({
  database,
  userId,
  courierTemplateId,
}: {
  database: Database;
  userId: string;
  courierTemplateId: string;
}): Promise<UserChannelPreferences> {
  const userPreferencesRef = ref(
    database,
    `channelPreferences/${userId}/${courierTemplateId}`
  );
  return new Promise((resolve, reject) => {
    onValue(
      userPreferencesRef,
      (snapshot) => {
        if (snapshot.exists()) {
          const preferences = snapshot.val() as Partial<UserChannelPreferences>;
          resolve({
            email: preferences.email ?? false,
            sms: preferences.sms ?? false,
            push: preferences.push ?? true,
          });
        } else {
          resolve({
            email: false,
            sms: false,
            push: true,
          });
        }
      },
      reject
    );
  });
}
